// extracted by mini-css-extract-plugin
export default {"css-frame":"dashboard_css-frame__vSrgm"};